<template lang="pug">
  .c
    li(ref="main", :style="styles")
</template>

<script>
export default {
  props:{
    index:Number,
  },
  data(){
    return {
      scrollY:0,
      modifier:-3
    }
  },
  mounted(){
    let change = 0.03;
    let interval = setInterval(()=>{
      if(Math.abs(this.modifier)>=5) change *= -1 // Switch Directions if amplitude reaches 3 or -3
      this.modifier += change
    }, 200)
  },
  computed:{
    styles(){
      return {
        transform:this.transform,
      }
    },
    transform(){
      let charge = this.index%2? -1 : 1,
      wavelength = 10,
      amplitude = 3,
      scaleModifier = 5
      let ratio = this.scrollY/(300 /* + this.scrollOrigin/window.innerHeight */)
      this.scrollOrigin
      let offset = Math.sin(ratio*amplitude*this.modifier)
      let scale = offset
      scale *= scaleModifier
      return `translateX(${offset}px) scale(${scale})`
    },

    borderRadius(){
      let offset = Math.sin(this.scrollY-this.scrollOrigin/30)*5*charge
    },

    scrollOrigin(){
      let el = this.$refs.main
      this.scrollY = el? el.offsetTop : 0;
      return this.$parent.scrollOrigin
    },

    id(){
      return `${Math.round(Math.random()*200000000)}`
    }

  }
}
</script>

<style lang="scss" scoped>
  .smooth{
    transition:transform 200ms linear;
  }
  li{
    @extend .smooth;
    opacity:0.6;
    padding:10px;
    font-size: 5px;
    width:10vw;
    z-index: 1;
  }
</style>


// WEBPACK FOOTER //
// Sine.vue?27f6d132